import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '../../../components/layouts/Layout'
import Form from '../../../components/PaymentForm/Form';
import LocalStorage from '../../../hook/LocalStorage';
import amx from '../../../assets/images/payment/amx.png'
import masterCard from '../../../assets/images/payment/mastercard.png'
import visa from '../../../assets/images/payment/visa.png'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import http from '../../../config/BaseUrl';
import { eventCreateReset } from './slice/createEventSlice';
const EventDevice = () => {

    const { user } = LocalStorage();
    const dispatch = useDispatch()
    const history = useHistory()
    const { register, handleSubmit, formState: { errors }, setError, watch, setValue } = useForm({ mode: "all", reValidateMode: "all" })
    const [loading, setLoading] = useState(false)
    const { eventId } = useSelector(state => state.createEvent)

    const device = [
        {
            id: 1,
            name: "device 1",
            price: 50,
        },
        {
            id: 2,
            name: "device 2",
            price: 100,
        },
        {
            id: 3,
            name: "device 3",
            price: 150,
        },
    ];

    const PayWithDeviceEvent = async (data) => {
        const formData = {
            cardNumber: data.cardNumber,
            cardholderName: data.cardholderName,
            cvvNumber: data.cvvNumber,
            expiryMonth: data.expiryMonth,
            expiryYear: data.expiryYear,
            user_id: user.id,
            user_email: user.email,
            sources: user.membership.sources,
            package_id: user.membership.package_id,
            package_type: user.membership.package_type,
            event_id: eventId,
            submittedData: data
        }


        if (eventId !== null) {
            try {
                setLoading(true)
                const eventPayment = await http.post("event-payment", formData)
                    .then((res) => {
                        if (res.data.card_info) {
                            setLoading(false)
                            return res.data.card_info
                        } else {
                            history.goBack()
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            console.log(error.response.data);
                            console.log(error.response.status);
                            console.log(error.response.headers);
                        } else if (error.request) {
                            console.log(error.request);
                        } else {
                            console.log('Error', error.message);
                        }
                    })

                if (eventPayment && eventPayment.charge_id !== null) {
                    await http.post(`event/store/${eventId}`).then((res) => {
                        if (res.data.status === true) {
                            setLoading(false)
                            dispatch(eventCreateReset())
                            localStorage.removeItem("persist:root")
                            history.push('/event#live')
                        }
                    }).catch((err) => setLoading(false))
                } else {
                    setLoading(false)
                    history.goBack()
                }


            } catch (error) {
                console.log(error.message);
            }
        }


    }

    const DeviceItemValue = watch("device");
    if (DeviceItemValue) {
        const devicePrice = device.filter(item => item.name === DeviceItemValue);
        const totalPrice = devicePrice && devicePrice[0]?.price
        setValue("price", totalPrice)
    }
    return (
        <Layout>
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="mt-5 card radius-15">
                        <div className="py-4 text-center border-bottom">
                            <h4 className="mb-0 text-primary display-4 event-form-title">Chose device and pay</h4>
                        </div>
                        <div className="py-5 m-3 card-body">
                            <div className="row justify-content-center align-items-center h-100">
                                <div className="col-md-10 col-lg-10 col-xl-6 col-sm-8 col-12">
                                    <div className="payment-form" style={{ height: "50vh" }}>
                                        <div className="payment-form-body">
                                            <form onSubmit={handleSubmit(PayWithDeviceEvent)}>
                                                <div className="text-center form-header border-bottom payment-form-header">
                                                    <h4 className="text-secondary text-uppercase">Card Information</h4>
                                                    <div className="payment-images">
                                                        <div className="card-item">
                                                            <img src={visa} className="img-fluid" alt="visa" />
                                                        </div>
                                                        <div className="card-item">
                                                            <img src={masterCard} className="img-fluid" alt="masterCard" />
                                                        </div>
                                                        <div className="card-item">
                                                            <img src={amx} className="img-fluid" alt="amx" />
                                                        </div>
                                                    </div>
                                                </div>
                                                {user && user.membership.package_type === 'single' && (
                                                    <div className="pt-3 form-row">
                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="ChoseDevice">Chose Device</label>
                                                            <select className="form-control" id="ChoseDevice" {...register("device")} required>
                                                                <option value="">Select device</option>
                                                                {device && device.map((item, index) => (
                                                                    <option key={index} value={item.name}>{item.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="DevicePrice">Device Price</label>
                                                            <input type="text" {...register("price", { require: true })} readOnly className="form-control" id="DevicePrice" placeholder="Device price" />
                                                        </div>

                                                    </div>
                                                )}
                                                <Form register={register} errors={errors} watch={watch} setValue={setValue} />
                                                <div id="addExistBtn">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary btn-block"
                                                    >
                                                        {loading && loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
                                                            : (" Purchase Event")
                                                        }
                                                    </button>
                                                </div>
                                            </form>
                                        </div>

                                        <div className="payment-page-footer">
                                            <p onClick={() => history.goBack()} className="text-primary" style={{ cursor: 'pointer' }}>Back To Previous Page</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default EventDevice
